import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './index.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import { useDocTitle } from './components/CustomHook';
import ScrollToTop from './components/ScrollToTop';
import LoadingScreen from './components/LoadingScreen'; // Assurez-vous que le chemin est correct

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let initialized = false;

    const aosInit = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: 'ease-out-cubic',
      });
    };

    const handleLoad = () => {
      if (initialized) {
        return;
      }

      initialized = true;
      aosInit();
      setTimeout(() => {
        setLoading(false);
      }, 2500);
    };

    window.addEventListener('load', handleLoad);

    if (document.readyState === 'complete') {
      handleLoad();
    }

    return () => {
      window.removeEventListener('load', handleLoad);
    };
  }, []);

  useDocTitle('Amonthanat Massage | Traditional Thai Massage in Kathu, Phuket');

  return (
    <>
      {loading ? (
        <LoadingScreen />
      ) : (
        <Router>
          <ScrollToTop>
            <Routes>
              <Route path="/" element={<Home />} />
            </Routes>
          </ScrollToTop>
        </Router>
      )}
    </>
  );
}

export default App;
